import { render, staticRenderFns } from "./Rare3YOYsortButton.vue?vue&type=template&id=3bb1aeef&scoped=true"
import script from "./Rare3YOYsortButton.vue?vue&type=script&lang=js"
export * from "./Rare3YOYsortButton.vue?vue&type=script&lang=js"
import style0 from "./Rare3YOYsortButton.vue?vue&type=style&index=0&id=3bb1aeef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb1aeef",
  null
  
)

export default component.exports